import { ClearOutlined, FilePdfOutlined, PrinterOutlined } from "@ant-design/icons";
import { Button, Col, DatePicker, Drawer, Empty, Form, Radio, RadioChangeEvent, Row, Select, Spin, Tooltip, TreeSelect, Image, Flex, Skeleton } from "antd";
import { useEffect, useRef, useState } from "react";
import * as Icon from "phosphor-react";
import { useAppDispatch, useAppSelector } from "../../../util/hooks";
import { gerarRelatorioContaFinanceira } from "../../../services/relatorioService";
import { buscarEmpresa } from "../../../services/empresaService";
import { clearRelatorio } from "../../../redux/slices/relatorio/relatorioSlice";
import { SelectModel } from "../../../models/treeModel";
import { ContaPagamentoRecebimentoModel } from "../../../models/relatorio/ContaPagamentoRecebimentoModel";
import dayjs from "dayjs";
import { listarSorteio } from "../../../services/sorteioService";
import { setTitle } from "../../../redux/slices/configuracoes/configuracoesSlice";
import { useLocation } from "react-router-dom";
import { buscarContaBanco } from "../../../services/contaBancoService";
import { Vm_ContaBancoModel } from "../../../models/contaBanco/vm_contaBancoModel";
import { buscarPessoa } from "../../../services/pessoaService";
import { PessoaModel } from "../../../models/pessoa/pessoaModel";
import React from "react";
import { currencyBRL } from "../../../util/dinheiroBRAuxiliar";
import "./style/index.scss";
import { RelatoriosContasFinanceiraVM } from "../../../models/relatorio/RelatorioContasFinanceiraVM";
import { useReactToPrint } from "react-to-print";
import { buscarCentroCusto } from "../../../services/centroCustoService";
import { buscarPlanoContaFinanceiro } from "../../../services/planoContaFinanceiroService";
import SelectTree from "../../../components/inputs/selectTree";

interface RelatorioAgrupado {
  denominacaoGrupo: string;
  itens: RelatoriosContasFinanceiraVM[];
}

interface FiltrosImpresso {
  empresas: string;
  pessoas: string;
  favorecidas: string;
  vencimento: string;
}

const ContaPagamentoRecebimentoRelatorio = () => {
  //estados globais
  const relatorioState = useAppSelector((state) => state.relatorio);
  const empresaState = useAppSelector((state) => state.empresa);
  const contaBancoState = useAppSelector((state) => state.contaBanco);
  const centroCustoState = useAppSelector((state) => state.centroCusto);
  const persistedState = useAppSelector((state) => state.persisted);
  const pessoaState = useAppSelector((state) => state.pessoa);
  const sorteioState = useAppSelector((state) => state.sorteio);
  const planoContaFinanceiroState = useAppSelector((state) => state.planoContaFinanceiro);

  //hooks
  const dispatch = useAppDispatch();
  const location = useLocation();

  //estados locais
  const [form] = Form.useForm<any>();
  const [abrirFiltroAvancado, setAbrirFiltroAvancado] = useState<boolean>(false);
  const [formFiltrosAvancados] = Form.useForm();
  const [listaFinal, setListaFinal] = useState<RelatorioAgrupado[]>([]);
  const relatorioContas = useRef<HTMLDivElement>(null);
  const [filtrosImpressao, setFiltroImpressao] = useState<FiltrosImpresso | null>(null);
  const dataAgora = dayjs().format("DD/MM/YYYY [às] HH:mm");

  const [empresasSelecionadas, setEmpresaSelecionada] = useState([]);
  const [pessoasSelecionadas, setPessoaSelecionada] = useState([]);
  const [favorecidosSelecionadas, setFavorecidoSelecionado] = useState([]);

  const contasRecebimento = location.pathname === "/relatorioContaRecebimento";

  const selectSituacao = [
    { label: "CANCELADO", value: "1" },
    { label: "NÃO PAGO", value: "2" },
    { label: "PAGO", value: "3" },
  ];

  let selectAgrupamento = [
    { label: "Conta bancária", value: "CONTABANCO" },
    { label: "Empresa", value: "EMPRESA" },
    { label: "Cliente", value: "PESSOA" },
    { label: "Favorecido", value: "FAVORECIDO" },
    { label: "Vencimento", value: "VENCIMENTO" },
    { label: "Mês vencimento", value: "MESVENCIMENTO" },
    { label: "Emissão", value: "EMISSAO" },
    { label: "Mês emissão", value: "MESEMISSAO" },
    { label: "Situação", value: "SITUACAO" },
    { label: "Sorteio", value: "SORTEIO" },
  ];

  selectAgrupamento = selectAgrupamento.sort((a, b) => a.label.localeCompare(b.label));

  useEffect(() => {
    dispatch(clearRelatorio([]));
    dispatch(buscarEmpresa(empresaState.busca));
    dispatch(buscarCentroCusto(centroCustoState.busca));
    dispatch(buscarContaBanco({ pesquisar: null, id: null, idEmpresa: null }));
    dispatch(
      buscarPessoa({ ...pessoaState.busca, idCategoriaPessoa: contasRecebimento ? "2" : "1", exibeContaPagar: contasRecebimento ? null : true, exibeContaReceber: contasRecebimento ? true : false })
    );
    form.setFieldsValue({ tipoDataConta: "EMISS", visualizacao: true, dataInicio: dayjs().startOf("week"), dataFim: dayjs().endOf("week") });
    if (contasRecebimento) {
      dispatch(setTitle("RELATÓRIO DE CONTAS A RECEBER"));
    } else {
      dispatch(setTitle("RELATÓRIO DE CONTAS A PAGAR"));
    }
  }, [location]);

  const carregarRelatorio = async (value: any) => {
    dispatch(clearRelatorio({}));

    const values = await form.validateFields();
    let formAvancados = formFiltrosAvancados.getFieldsValue();

    let filtrosDescricaoEmpresas = empresasSelecionadas
      .map((selectedValue) => {
        let empresa = empresaState.list.find((item: { id: any }) => item.id === selectedValue);
        return empresa ? empresa.apelido : null;
      })
      .filter(Boolean)
      .join(", ");

    let filtrosDescricaoCliente = pessoasSelecionadas
      .map((selectedValue) => {
        let pessoa = pessoaState.list.find((item: { id: any }) => item.id === selectedValue);
        return pessoa ? pessoa.apelido : null;
      })
      .filter(Boolean)
      .join(", ");

    let filtrosDescricaoFavorecido = favorecidosSelecionadas
      .map((selectedValue) => {
        let favorecido = pessoaState.list.find((item: { id: any }) => item.id === selectedValue);
        return favorecido ? favorecido.apelido : null;
      })
      .filter(Boolean)
      .join(", ");

    let filtrosDescric: FiltrosImpresso = {
      empresas: filtrosDescricaoEmpresas ? filtrosDescricaoEmpresas : "Todas",
      pessoas: filtrosDescricaoCliente ? filtrosDescricaoCliente : "Todos",
      favorecidas: filtrosDescricaoFavorecido ? filtrosDescricaoFavorecido : "Todos",
      vencimento: dayjs(values.dataInicio).format("DD/MM/YYYY") + " a " + dayjs(values.dataFim).format("DD/MM/YYYY"),
    };

    let parametros: ContaPagamentoRecebimentoModel = {
      receitaDespesa: contasRecebimento ? "R" : "D",
      tipoDataConta: value.tipoDataConta,
      dataInicio: dayjs(values.dataInicio).format("YYYY-MM-DD"),
      dataFim: dayjs(values.dataFim).format("YYYY-MM-DD"),
      campoAgrupamento: formAvancados.campoAgrupamento,
      idSorteio: formAvancados.idSorteio,
      filtroSituacao: formAvancados.filtroSituacao?.join("|"),
      filtroPessoa: formAvancados.idPessoa?.join("|"),
      filtroPessoaFavorecida: formAvancados.idPessoaFavorecido?.join("|"),
      filtroCentroCusto: formAvancados.idCentroCusto?.join("|"),
      filtroPlanoContaFinanceiro: formAvancados.idPlanoContaFinanceiro?.join("|"),
      filtroEmpresa: values.idEmpresa?.join("|"),
      filtroContaBanco: formAvancados.idContaBanco?.join("|"),
    };

    let result = await dispatch(gerarRelatorioContaFinanceira(parametros));
    setFiltroImpressao(filtrosDescric);
    criarAgrupamento(result.payload);
  };

  const handlePrint = useReactToPrint({
    content: () => relatorioContas.current,
  });

  const criarAgrupamento = (lista: RelatoriosContasFinanceiraVM[]) => {
    let listGroup: Record<string, RelatoriosContasFinanceiraVM[]> = lista.reduce((agrupamento, item) => {
      const key = item.denominacaoGrupo;
      if (!(key in agrupamento)) {
        agrupamento[key] = [];
      }
      agrupamento[key].push(item);
      return agrupamento;
    }, {} as Record<string, RelatoriosContasFinanceiraVM[]>);

    let listaAgrupadaArray: RelatorioAgrupado[] = Object.keys(listGroup).map((key) => ({
      denominacaoGrupo: key,
      itens: listGroup[key],
    }));

    setListaFinal(listaAgrupadaArray);
    return listaAgrupadaArray;
  };

  const onChangeEmpresa = (values: any) => {
    let itensSelecionados = values.map((value: any) => value);
    setEmpresaSelecionada(itensSelecionados);
    dispatch(listarSorteio(itensSelecionados.map(String).toString()));
    const searchEmpresa = empresaState.list.filter((empresa: any) => itensSelecionados.includes(empresa.id));

    if (persistedState.user.empresa?.idEmpresa !== null && persistedState.user.perfil !== "AUDITORIA") {
      dispatch(buscarPlanoContaFinanceiro({ ...planoContaFinanceiroState.busca, idGrupoPlanoContaFinanceiro: empresaState.list[0].idGrupoPlanoContaFinanceiro }));
    } else {
      dispatch(buscarPlanoContaFinanceiro({ ...planoContaFinanceiroState.busca, idGrupoPlanoContaFinanceiro: searchEmpresa[0].idGrupoPlanoContaFinanceiro }));
    }

    formFiltrosAvancados.setFieldValue("idPlanoContaFinanceiro", undefined);
  };

  const handleChangeCliente = async (values: any) => {
    let itensSelecionados = values.map((value: any) => value);
    setPessoaSelecionada(itensSelecionados);
  };

  const handleChangeFavorecido = async (values: any) => {
    let itensSelecionados = values.map((value: any) => value);
    setFavorecidoSelecionado(itensSelecionados);
  };

  const handleChangeSituacao = async (values: any) => {
    let itensSelecionados = values.map((value: any) => value);
    let itensEmPipe = itensSelecionados.join("|");
  };

  const generateTree = (value: SelectModel[] = []) => {
    var retorno: any[] = [];
    value.map(({ children, ...props }: any) => {
      if (children?.length === 0) {
        children = undefined;
      }
      retorno.push({
        value: props.id,
        title: props.title,
        disabled: props.sinteticoAnalitico?.toLowerCase() === "s" || children !== undefined || !props.ativo,
        children: generateTree(children),
      });
    });
    return retorno;
  };

  const CloseFiltros = () => {
    setAbrirFiltroAvancado(false);
  };

  const resetFiltrosAvancados = () => {
    formFiltrosAvancados.resetFields();
  };

  const RelatorioHtml = React.forwardRef<HTMLDivElement>((_props, ref) => {
    return (
      <div ref={ref} className="relatorios-html-format">
        <div className="rel-cabecalho">
          <div className="rel-titulo">
            <h2>
              <strong>{contasRecebimento ? "Contas a receber / Recebimentos" : "Contas a pagar / Pagamentos"}</strong>
            </h2>
            <p>Gerado em {dataAgora}</p>
          </div>
          <hr />
          {contasRecebimento ? (
            <p>{"Empresa: " + filtrosImpressao?.empresas + "; Vencimento: " + filtrosImpressao?.vencimento + "; Cliente: " + filtrosImpressao?.pessoas}</p>
          ) : (
            <p>
              {"Empresa: " +
                filtrosImpressao?.empresas +
                "; Vencimento: " +
                filtrosImpressao?.vencimento +
                "; Fornecedor: " +
                filtrosImpressao?.pessoas +
                "; Favorecido: " +
                filtrosImpressao?.favorecidas}
            </p>
          )}
        </div>
        <div className="rel-detalhes">
          <table className="tb-dados">
            {listaFinal.map((agrupamento) => {
              let totalValorBruto = 0;
              let totalValorLiquido = 0;
              let totalValorPago = 0;
              let totalValorEncargos = 0;
              let totalValorDesconto = 0;
              let totalSaldoContaFinanceira = 0;
              return (
                <React.Fragment key={agrupamento.denominacaoGrupo}>
                  <thead style={{ fontSize: "10px" }}>
                    <tr>
                      <th colSpan={9} className="ht-left">
                        {agrupamento.denominacaoGrupo}
                      </th>
                    </tr>
                  </thead>
                  <thead>
                    <tr className="header-table">
                      <th className="ht-left">Emissão</th>
                      <th className="ht-left">Vencimento</th>
                      <th className="ht-center">Nº Doc</th>
                      <th className="ht-left">{contasRecebimento ? "Cliente" : "Fornecedor"}</th>
                      {!contasRecebimento && <th className="ht-left">Favorecido</th>}
                      <th className="ht-right">Vl. Bruto</th>
                      <th className="ht-right">Vl. Liquido</th>
                      <th className="ht-right">Vl. Recebido &#40;R$&#41;</th>
                      <th className="ht-right">Vl. Encargos Rec. &#40;R$&#41;</th>
                      <th className="ht-right">Vl. Desc. Conced. &#40;R$&#41;</th>
                      <th className="ht-right">Saldo</th>
                    </tr>
                  </thead>
                  <tbody className="body-table">
                    {agrupamento.itens.map((t) => {
                      totalValorBruto += t.valorBruto;
                      totalValorLiquido += t.valorLiquido;
                      totalValorPago += t.valorPago;
                      totalValorEncargos += t.valorEncargos;
                      totalValorDesconto += t.valorDesconto;
                      totalSaldoContaFinanceira += t.saldoContaFinanceira;
                      return (
                        <React.Fragment key={t.idContaFinanceira}>
                          <tr>
                            <td className="ht-left">{dayjs(t.dataEmissao).format("DD/MM/YYYY")}</td>
                            <td className="ht-left" style={{ whiteSpace: "nowrap" }}>
                              {t.dataVencimento}
                            </td>
                            <td className="ht-center">{t.numeroDocumento}</td>
                            <td className="ht-left">{t.denominacaoPessoa}</td>
                            {!contasRecebimento && <td className="ht-left">{t.denominacaoPessoaFavorecido}</td>}
                            <td className="ht-right">{currencyBRL(t.valorBruto)}</td>
                            <td className="ht-right">{currencyBRL(t.valorLiquido)}</td>
                            <td className="ht-right">{currencyBRL(t.valorPago)}</td>
                            <td className="ht-right">{currencyBRL(t.valorEncargos)}</td>
                            <td className="ht-right">{currencyBRL(t.valorDesconto)}</td>
                            <td className="ht-right">&nbsp;&nbsp;&nbsp;{currencyBRL(t.saldoContaFinanceira)}</td>
                          </tr>
                          <tr>
                            <td colSpan={2}></td>
                            <td className="ht-left" colSpan={6}>
                              <strong>Histórico:</strong> {t.historico}
                            </td>
                          </tr>
                          <tr>
                            <td colSpan={contasRecebimento ? 10 : 11}>
                              <hr />
                            </td>
                          </tr>
                        </React.Fragment>
                      );
                    })}
                    <tr style={{ fontSize: "14px", height: "25px", background: "darkgray", borderTop: "1px solid" }}>
                      <td className="ht-left" colSpan={contasRecebimento ? 4 : 5}>
                        <strong>Total &#40;R$&#41;:</strong>
                      </td>
                      <td className="ht-right">{currencyBRL(totalValorBruto)}</td>
                      <td className="ht-right">{currencyBRL(totalValorLiquido)}</td>
                      <td className="ht-right">{currencyBRL(totalValorPago)}</td>
                      <td className="ht-right">{currencyBRL(totalValorEncargos)}</td>
                      <td className="ht-right">{currencyBRL(totalValorDesconto)}</td>
                      <td className="ht-right">&nbsp;&nbsp;&nbsp;{currencyBRL(totalSaldoContaFinanceira)}</td>
                    </tr>
                  </tbody>
                </React.Fragment>
              );
            })}
          </table>
        </div>
      </div>
    );
  });

  return (
    <Flex vertical>
      <Form form={form} layout="vertical" onFinish={carregarRelatorio}>
        <Row gutter={12} align="bottom">
          <Col span={20}>
            <Flex gap={12}>
              <Form.Item name="idEmpresa" label="Empresa">
                <Select
                  showSearch
                  mode="multiple"
                  optionFilterProp="label"
                  style={{ width: 500 }}
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => (
                    <Tooltip
                      title={
                        <ul style={{ paddingLeft: 16, margin: 0 }}>
                          {omittedValues.map((field, index) => (
                            <li key={index}>{field.label}</li>
                          ))}
                        </ul>
                      }
                    >
                      <span>{`+ ${omittedValues.length} ...`}</span>
                    </Tooltip>
                  )}
                  placeholder="Selecione as empresas"
                  onChange={onChangeEmpresa}
                  loading={empresaState.loading}
                  options={empresaState.list.map((a: any) => ({
                    value: a.id,
                    label: a.apelido,
                  }))}
                />
              </Form.Item>
              <Form.Item label="Data início" name="dataInicio">
                <DatePicker placeholder="" format="DD/MM/YYYY" style={{ width: 120 }} />
              </Form.Item>
              <Form.Item label="Data fim" name="dataFim">
                <DatePicker placeholder="" format="DD/MM/YYYY" style={{ width: 120 }} />
              </Form.Item>
              <Form.Item name="botaoFiltro" label=" ">
                <Tooltip title="Filtros avançados">
                  <Button onClick={() => setAbrirFiltroAvancado(!abrirFiltroAvancado)} className={abrirFiltroAvancado ? "funnelIconOpen" : ""}>
                    <Icon.Funnel size={16} color={abrirFiltroAvancado ? "#ffffff" : "#212937"} weight="fill" style={{ marginTop: 2 }} />
                  </Button>
                </Tooltip>
              </Form.Item>
            </Flex>
          </Col>
          <Col span={4}>
            <Flex justify="end" gap={12}>
              <Form.Item name="botaoCarregar" label=" ">
                <Button icon={<PrinterOutlined />} onClick={handlePrint} disabled={relatorioState.loadingContaFinanceira}></Button>
              </Form.Item>
              <Form.Item name="botaoCarregar" label=" ">
                <Button className="buttonPrimary" icon={<FilePdfOutlined />} htmlType="submit">
                  Carregar relatório
                </Button>
              </Form.Item>
            </Flex>
          </Col>
        </Row>
        <Row gutter={12} align="bottom">
          <Col span={24}>
            <Flex gap={12}>
              <Form.Item label="Por datas de:" name="tipoDataConta">
                <Radio.Group style={{ width: "100%" }} optionType="button" buttonStyle="solid">
                  <Radio.Button value={"COMPET"}>Competência</Radio.Button>
                  <Radio.Button value={"EMISS"}>Emissão</Radio.Button>
                  <Radio.Button value={"VENCIM"}>Vencimento</Radio.Button>
                </Radio.Group>
              </Form.Item>
            </Flex>
          </Col>
        </Row>
      </Form>
      <Row gutter={12} style={{ paddingTop: "24px" }}>
        <Col span={24}>
          {relatorioState.listContaFinanceira.length === 0 && !relatorioState.loadingContaFinanceira && (
            <div
              style={{
                background: "white",
                display: "grid",
                width: "100%",
                height: "500px",
                alignItems: "center",
              }}
            >
              <Empty description={"O seu relatório será exibido aqui"} />
            </div>
          )}
          {relatorioState.listContaFinanceira.length === 0 && relatorioState.loadingContaFinanceira && <Skeleton.Button style={{ height: 500 }} active block />}
          {relatorioState.listContaFinanceira.length !== 0 && !relatorioState.loadingContaFinanceira && <RelatorioHtml ref={relatorioContas}></RelatorioHtml>}
        </Col>
      </Row>
      <Drawer width={500} title="FILTROS AVANÇADOS" placement="right" onClose={CloseFiltros} open={abrirFiltroAvancado} getContainer={false}>
        <Form layout="vertical" form={formFiltrosAvancados}>
          <Row gutter={12}>
            <Col span={24}>
              <Form.Item label="Agrupado por" name="campoAgrupamento">
                <Select
                  showSearch
                  optionFilterProp="label"
                  placeholder="selecione um agrupamento"
                  options={selectAgrupamento.map((a: any) => ({
                    value: a.value,
                    label: a.label,
                  }))}
                />
              </Form.Item>
              <Form.Item label={"Cliente"} name="idPessoa" style={{ width: "100%" }}>
                <Select
                  showSearch
                  mode="multiple"
                  style={{ width: "100%" }}
                  optionFilterProp="label"
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => (
                    <Tooltip
                      title={
                        <ul style={{ paddingLeft: 16, margin: 0 }}>
                          {omittedValues.map((field, index) => (
                            <li key={index}>{field.label}</li>
                          ))}
                        </ul>
                      }
                    >
                      <span>{`+ ${omittedValues.length} ...`}</span>
                    </Tooltip>
                  )}
                  placeholder={"Selecione o cliente"}
                  onChange={handleChangeCliente}
                  loading={pessoaState.loading}
                  options={pessoaState.list.map((a: PessoaModel) => ({
                    value: a.id,
                    label: a.apelido,
                    disabled: !a.ativo,
                  }))}
                />
              </Form.Item>
              {!contasRecebimento && (
                <Form.Item label={"Fornecedor"} name="idPessoaFavorecido" style={{ width: "100%" }}>
                  <Select
                    showSearch
                    mode="multiple"
                    style={{ width: "100%" }}
                    optionFilterProp="label"
                    maxTagCount="responsive"
                    maxTagPlaceholder={(omittedValues) => (
                      <Tooltip
                        title={
                          <ul style={{ paddingLeft: 16, margin: 0 }}>
                            {omittedValues.map((field, index) => (
                              <li key={index}>{field.label}</li>
                            ))}
                          </ul>
                        }
                      >
                        <span>{`+ ${omittedValues.length} ...`}</span>
                      </Tooltip>
                    )}
                    placeholder={"Selecione o fornecedor"}
                    onChange={handleChangeFavorecido}
                    loading={pessoaState.loading}
                    options={pessoaState.list.map((a: PessoaModel) => ({
                      value: a.id,
                      label: a.apelido,
                      disabled: !a.ativo,
                    }))}
                  />
                </Form.Item>
              )}
              <Form.Item label="Conta Bancária" name="idContaBanco">
                <Select
                  showSearch
                  optionFilterProp="label"
                  mode="multiple"
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => (
                    <Tooltip
                      title={
                        <ul style={{ paddingLeft: 16, margin: 0 }}>
                          {omittedValues.map((field, index) => (
                            <li key={index}>{field.label}</li>
                          ))}
                        </ul>
                      }
                    >
                      <span>{`+ ${omittedValues.length} ...`}</span>
                    </Tooltip>
                  )}
                  placeholder="Selecione a conta banco"
                  loading={contaBancoState.loading}
                  options={contaBancoState.list.map((a: Vm_ContaBancoModel) => ({
                    value: a.id,
                    label: a.denominacaoPersonalizada,
                    disabled: !a.ativo,
                  }))}
                />
              </Form.Item>
              <Form.Item label="Plano de conta financeiro" name="idPlanoContaFinanceiro">
                <SelectTree loading={planoContaFinanceiroState.loading} list={planoContaFinanceiroState.list} />
              </Form.Item>
              <Form.Item label="Centro de custo" name="idCentroCusto">
                <SelectTree loading={centroCustoState.loading} list={centroCustoState.list} />
              </Form.Item>
              <Form.Item
                label="Situação"
                name="filtroSituacao"
                rules={[
                  {
                    required: false,
                    message: "",
                  },
                ]}
              >
                <Select
                  showSearch
                  mode="multiple"
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => (
                    <Tooltip
                      title={
                        <ul style={{ paddingLeft: 16, margin: 0 }}>
                          {omittedValues.map((field, index) => (
                            <li key={index}>{field.label}</li>
                          ))}
                        </ul>
                      }
                    >
                      <span>{`+ ${omittedValues.length} ...`}</span>
                    </Tooltip>
                  )}
                  optionFilterProp="label"
                  placeholder="Selecione uma ou mais situações"
                  onChange={handleChangeSituacao}
                  options={selectSituacao.map((a: any) => ({
                    value: a.value,
                    label: a.label,
                  }))}
                />
              </Form.Item>
              <Form.Item label="Data do sorteio" name="idSorteio">
                <Select
                  showSearch
                  optionFilterProp="label"
                  style={{ width: "100%" }}
                  loading={sorteioState.loadingEmpresas}
                  options={sorteioState.listSorteioEmpresas.map((a: any) => ({
                    value: a.idSorteio,
                    label: dayjs(a.dataSorteio).format("DD/MM/YYYY"),
                  }))}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <Row>
          <Col className="cadastrarCol" style={{ width: "100%" }}>
            <Button className="buttonPrimary" icon={<ClearOutlined />} style={{ width: "100%" }} onClick={resetFiltrosAvancados}>
              Limpar filtros
            </Button>
          </Col>
        </Row>
      </Drawer>
    </Flex>
  );
};

export default ContaPagamentoRecebimentoRelatorio;
